<template>
    <div>
        <div class="row mt-5" id="settings">
            <div class="col-lg-12 text-center">
                <h2>تنظیمات</h2>
            </div>
            <div class="col-lg-8 offset-lg-2 mt-5">
                <!--<h4 class="mb-4">تم:</h4>-->
                <div class="row">
                    <div class="col-md-4 mb-3" @click="onThemeChanged($event, 'default')">
                        <div class="row theme-container m-0">
                            <div class="col-8 d-flex align-items-center">
                                <h4 class="mb-0">Default</h4>
                            </div>
                            <div class="col-4 theme-color" style="background-color: white"></div>
                        </div>
                    </div>
                    <div class="col-md-4 mb-3" @click="onThemeChanged($event, 'starry-night')">
                        <div class="row theme-container m-0">
                            <div class="col-8 d-flex align-items-center">
                                <h4 class="mb-0">Starry Night</h4>
                            </div>
                            <div class="col-4 theme-color" style="background-color: #606c88"></div>
                        </div>
                    </div>
                    <div class="col-md-4 mb-3" @click="onThemeChanged($event, 'dark')">
                        <div class="row theme-container m-0">
                            <div class="col-8 d-flex align-items-center">
                                <h4 class="mb-0">Dark</h4>
                            </div>
                            <div class="col-4 theme-color" style="background-color: #33333d"></div>
                        </div>
                    </div>
                </div>
                <div class="row mt-5 border-bottom">
                    <div class="col-6">
                        <h4>بارگذاری خودکار</h4>
                    </div>
                    <div class="col-6 text-left">
                        <toggle-button id="changed-font" class="m-0 ml-5" :color="{checked: '#00c853', unchecked: '#90a4ae'}" :value="autoload" :sync="true" @change="onAutoloadChange"/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import EventBus from '../_framework/event-bus.js';
    import * as $ from "jquery";
    export default {
        data() {
            return {
                listView: false,
                autoload: false
            }
        },
        mounted() {
            if (JSON.parse(localStorage.getItem("autoload")) === true) {
                this.autoload = true;
            }
            /*this.listView = JSON.parse(localStorage.getItem("listView"));
            $("body").addClass("starry-night");
            $(function () {
                $('[data-toggle="tooltip"]').tooltip()
            })*/
        },
        methods: {
            onThemeChanged(e, name) {
                EventBus.$emit('theme', name);
                localStorage.setItem("theme", name);
            },
            onAutoloadChange(e) {
                EventBus.$emit('autoload', e.value);
                if (e.value === true) {
                    this.autoload = true;
                    localStorage.setItem("autoload", "true");
                } else {
                    this.autoload = false;
                    localStorage.setItem("autoload", "false");
                }
            }
        }
    }
</script>